import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const jobFunctions = createReducer(null, {
    [types.COMBO_JOB_FUNCTION](state, action) {
        let newState = action.functions;
        return newState;
    }
});

export const jobLocations = createReducer(null, {
    [types.COMBO_JOB_LOCATION](state, action) {
        let newState = action.locations;
        return newState;
    }
});

export const jobTypes = createReducer(null, {
    [types.COMBO_JOB_TYPE](state, action) {
        let newState = action.jobType;
        return newState;
    }
});


// WEBPACK FOOTER //
// ./src/reducers/combo.js